module.exports = __webpack_public_path__ + "img/13-sdg-border@2x.c98e1a4b.png";